<template>
  <CustomPage title="我的团队">
    <div slot="content" class="content">
      <Navbar ref="Navbar" @getData="getData" />
      <List :data="data" />
    </div>
  </CustomPage>
</template>

<script>
import CustomPage from '@/components/custom-page.vue'
import Navbar from './components/Navbar'
import List from './components/List'
import { getTeamList } from '@/api/store/storeTeam'
export default {
  components: { CustomPage, Navbar, List },
  data() {
    return {
      data: [],
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      const params = this.$refs.Navbar.form
      getTeamList(params).then((res) => {
        this.data = res.data
      })
    },
  },
}
</script>

<style lang="less" scoped>
.content {
  background: #f7f7f7;
  min-height: 100%;
}
</style>